var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStairs224Dp5F6368Fill0Wght400Grad0Opsz24 = function SvgStairs224Dp5F6368Fill0Wght400Grad0Opsz24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    fill: "#5f6368"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80-200v-80h240v-240h240v-240h320v80H640v240H400v240H80Z"
  })));
};
export default SvgStairs224Dp5F6368Fill0Wght400Grad0Opsz24;